import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ad97838&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5ad97838&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad97838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad97838')) {
      api.createRecord('5ad97838', component.options)
    } else {
      api.reload('5ad97838', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ad97838&scoped=true", function () {
      api.rerender('5ad97838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/index.vue"
export default component.exports